package com.github.jangalinski.tabweb._foundation.size

data object LARGE_X : SmallToLargeX
